import { ChevronLeft, ChevronRight, Link as Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { usePreviewSession } from "../../../contexts/PreviewSessionContext";
import HeaderUserActions from "./HeaderUserActions";

interface MainHeaderProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const MainHeader: React.FC<MainHeaderProps> = ({ isOpen, setIsOpen }) => {
  const previewSession = usePreviewSession();
  const inPreview = !!previewSession;

  return (
    <header
      className={`bg-[#05050f] shadow-md px-10 z-[2] py-[25px] flex items-start justify-between transition-all duration-300 w-full fixed ${
        isOpen ? "pl-[17.5rem]" : "pl-[7rem]"
      }`}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-[#0193F8] hover:bg-[#0193F8]/90 rounded-full p-1 shadow-md transition-colors duration-200"
      >
        {isOpen ? (
          <ChevronLeft className="h-4 w-4 text-white" />
        ) : (
          <ChevronRight className="h-4 w-4 text-white" />
        )}
      </button>

      {!inPreview && (
        <div className="flex items-center space-x-4">
          <Link
            to="https://www.linkedin.com/company/fixfinder-saas/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex group items-center justify-center gap-[8px] bg-[#0193F8] w-[127px] h-[32px] rounded-[60px] text-[16px] text-[#FFFFFF] font-[400] leading-[24px] hover:text-[#0392f8] hover:bg-[#fff] transition-colors"
          >
            <Linkedin
              size={20}
              className="text-[#0193F8] group-hover:bg-[#0193F8] p-[3px] group-hover:text-[#fff] bg-[#fff] rounded-full"
            />
            Follow us
          </Link>
          <p className="line w-[2px] h-[35px] shadow-[0px_0px_2px_#354894] rounded-full border-[#05050F] border-solid border-[1.5px]"></p>
          <HeaderUserActions />
        </div>
      )}
    </header>
  );
};

export default MainHeader;
